import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as requestsApi from "@/api/requests.api";
import type { MetricRequest, StatsResponse } from "@/types";

interface RequestsState {
  items: MetricRequest[];
  total: number;
  stats: StatsResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: RequestsState = {
  items: [],
  total: 0,
  stats: null,
  loading: false,
  error: null,
};

export const fetchRequests = createAsyncThunk(
  "requests/fetchAll",
  async (params: requestsApi.RequestParams) => requestsApi.getRequests(params),
);

export const fetchStats = createAsyncThunk(
  "requests/fetchStats",
  async (params: requestsApi.StatsParams) => requestsApi.getStats(params),
);

const requestsSlice = createSlice({
  name: "requests",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRequests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRequests.fulfilled, (state, action) => {
        state.items = action.payload.data;
        state.total = action.payload.total;
        state.loading = false;
      })
      .addCase(fetchRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch requests";
      })
      .addCase(fetchStats.fulfilled, (state, action) => {
        state.stats = action.payload;
      });
  },
});

export default requestsSlice.reducer;
